
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { BlogPostManager } from "./BlogPostManager";
import { BlogCategoryManager } from "./BlogCategoryManager";
import { SiteSettingsManager } from "./SiteSettingsManager";
import { FAQManager } from "./FAQManager";
import { AdminSidebar } from "./AdminSidebar";
import { Header } from "./Header";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { ServicesManager } from "./ServicesManager";
import { TestimonialsManager } from "./TestimonialsManager";
import { PatientJourneyManager } from "./PatientJourneyManager";
import { NossaHistoriaManager } from "./NossaHistoriaManager";

export function AdminDashboard() {
  const { signOut, profile } = useAuth();
  const [activeTab, setActiveTab] = useState("blog");

  const handleLogout = async () => {
    await signOut();
  };

  const renderContent = () => {
    switch (activeTab) {
      case "blog":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Posts do Blog</CardTitle>
            </CardHeader>
            <CardContent>
              <BlogPostManager />
            </CardContent>
          </Card>
        );
      case "categories":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Categorias do Blog</CardTitle>
            </CardHeader>
            <CardContent>
              <BlogCategoryManager />
            </CardContent>
          </Card>
        );
      case "servicos":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Página de Serviços</CardTitle>
            </CardHeader>
            <CardContent>
              <ServicesManager />
            </CardContent>
          </Card>
        );
      case "depoimentos":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Depoimentos</CardTitle>
            </CardHeader>
            <CardContent>
              <TestimonialsManager />
            </CardContent>
          </Card>
        );
      case "configuracoes":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Configurações do Site</CardTitle>
            </CardHeader>
            <CardContent>
              <SiteSettingsManager />
            </CardContent>
          </Card>
        );
      case "settings":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Configurações do Site</CardTitle>
            </CardHeader>
            <CardContent>
              <SiteSettingsManager />
            </CardContent>
          </Card>
        );
      case "pacientes":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Pacientes</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Funcionalidade em desenvolvimento...</p>
            </CardContent>
          </Card>
        );
      case "imprensa":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Imprensa</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Funcionalidade em desenvolvimento...</p>
            </CardContent>
          </Card>
        );
      case "tarefas":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Tarefas</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Funcionalidade em desenvolvimento...</p>
            </CardContent>
          </Card>
        );
      case "financeiro":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Financeiro</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Funcionalidade em desenvolvimento...</p>
            </CardContent>
          </Card>
        );
      case "calendario":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Calendário</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Funcionalidade em desenvolvimento...</p>
            </CardContent>
          </Card>
        );
      case "faq":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Perguntas Frequentes</CardTitle>
            </CardHeader>
            <CardContent>
              <FAQManager />
            </CardContent>
          </Card>
        );
      case "jornada":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Jornada do Paciente</CardTitle>
            </CardHeader>
            <CardContent>
              <PatientJourneyManager />
            </CardContent>
          </Card>
        );
      case "historia":
        return (
          <Card>
            <CardHeader>
              <CardTitle>Gerenciar Nossa História</CardTitle>
            </CardHeader>
            <CardContent>
              <NossaHistoriaManager />
            </CardContent>
          </Card>
        );
      default:
        return (
          <Card>
            <CardHeader>
              <CardTitle>Bem-vindo ao Painel Administrativo</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600">Selecione uma opção no menu lateral para começar.</p>
            </CardContent>
          </Card>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-6">
        <SidebarProvider>
          <div className="flex w-full">
            <AdminSidebar activeTab={activeTab} onTabChange={setActiveTab} />
            <SidebarInset className="flex-1">
              <div className="p-6">
                {/* Header */}
                <div className="flex justify-between items-center mb-8">
                  <div>
                    <h1 className="text-3xl font-bold font-primary text-gray-800">
                      Painel Administrativo
                    </h1>
                    <p className="text-gray-600 font-secondary">
                      Bem-vindo(a), {profile?.name || profile?.email}
                    </p>
                  </div>
                  <Button
                    onClick={handleLogout}
                    variant="outline"
                    className="flex items-center gap-2"
                  >
                    <LogOut className="w-4 h-4" />
                    Sair
                  </Button>
                </div>

                {/* Content */}
                <div className="w-full">
                  {renderContent()}
                </div>
              </div>
            </SidebarInset>
          </div>
        </SidebarProvider>
      </div>
    </div>
  );
}
